import { Route, Switch } from 'react-router-dom';
import { FC, useContext } from 'react';
import Menu, { MenuItem } from './components/Menu';
import Events from './pages/Events/Events';
import Libraries from './pages/Libraries';
import Configs from './pages/Configs/Configs';
import UnsupportedSources from './pages/MissingSources';
import HealthMonitor from './pages/HealthMonitor';
import Statistics from './pages/Statistics';
import Heartbeats from './pages/Heartbeats';
import { AuthContext } from './components/Authentication';
import History from "./pages/History";
import Error from "./pages/Error";
import Admin from "./pages/Admin/Admin";
import isAvailable from "./api/utils";


const App: FC<{ }> = () => {
    const { user } = useContext(AuthContext);
    if (!user) {
        return <div>Not authenticated.</div>;
    }

    const routing: Record<string, FC> = {
        '/': Events,
        '/error': Error,
        '/events': Events,
        '/libraries': Libraries,
        '/configs': Configs,
        '/health_monitor': HealthMonitor,
        '/statistics': Statistics,
        '/history': History,
        '/unsupported_sources': UnsupportedSources,
        '/heartbeats': Heartbeats,
        '/admin': Admin
    };


    const menuItems: MenuItem[] = Object.keys(routing).slice(2).map(path => ({
        path,
        disabled: !isAvailable(path, user)
    }));

    return (
        <>
            <Menu items={menuItems} />

            <Switch>
                {Object.entries(routing).map(([path, component]) => (
                    <Route exact {...{path, component, key: path}} />
                ))}
            </Switch>
        </>
    );
};

export default App;
